// The GA4 tag and its Consent Mode v2 defaults (everything denied) load statically
// in public/index.html so the tag is always detectable. This module only flips
// analytics consent to match the visitor's choice: granted once they opt in (and on
// load if they already had), denied when they withdraw.
//
// Neutrally named for the reason set out in preferences.ts.
import { allowsAnalytics, CONSENT_EVENT, type Consent } from './preferences';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function initAnalytics() {
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return; // tag blocked by an extension -- nothing to do
  if (allowsAnalytics()) gtag('consent', 'update', { analytics_storage: 'granted' });
  window.addEventListener(CONSENT_EVENT, (e) => {
    const detail = (e as CustomEvent<Consent>).detail;
    gtag('consent', 'update', { analytics_storage: detail?.analytics ? 'granted' : 'denied' });
  });
}
